module.exports = __webpack_public_path__ + "img/Sharpshooter.841be441.png";